var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 54.2857H36.6667C36.6667 57.4286 33.6667 60 30 60C26.3333 60 23.3333 57.4286 23.3333 54.2857ZM60 48.5714V51.4286H0V48.5714L6.66667 42.8571V25.7143C6.66667 16.8571 13.3333 9.14286 23.3333 6.57143V5.71429C23.3333 2.57143 26.3333 0 30 0C33.6667 0 36.6667 2.57143 36.6667 5.71429V6.57143C46.6667 9.14286 53.3333 16.8571 53.3333 25.7143V42.8571L60 48.5714ZM46.6667 25.7143C46.6667 17.7143 39.3333 11.4286 30 11.4286C20.6667 11.4286 13.3333 17.7143 13.3333 25.7143V45.7143H46.6667V25.7143Z",
    fill: "#077CA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/NotificationIcon.71f3b31011789daca63c42375e487af9.svg";
export { ForwardRef as ReactComponent };